
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-9f5178e0&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./GoodPage.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./GoodPage.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-9f5178e0!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./GoodPage.vue"),
  /* scopeId */
  "data-v-9f5178e0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/GoodPage/GoodPage.vue
// module id = 280
// module chunks = 1